module.exports = __webpack_public_path__ + "img/wallet.3f945b1a.svg";